export default "__VITE_ASSET__lTtzaNFN__"